import PropTypes from 'prop-types';
import * as TableContentState from 'SalesContentIndexUI/data/constants/TableContentState';
export default PropTypes.oneOf(Object.values(TableContentState));